export interface DocumentStatusPresentation {
  status: string
  className: string
  labelKey: string
  definitionKey?: string
}

const statusMap: Record<string, DocumentStatusPresentation> = {
  cancelled: { status: 'cancelled', className: 'cancelled', labelKey: 'docStatusC', definitionKey: 'docStatusDefinitionC' },
  CAN: { status: 'cancelled', className: 'cancelled', labelKey: 'docStatusC', definitionKey: 'docStatusDefinitionC' },
  superceded: { status: 'superceded', className: 'superceded', labelKey: 'docStatusS', definitionKey: 'docStatusDefinitionS' },
  superseded: { status: 'superceded', className: 'superceded', labelKey: 'docStatusS', definitionKey: 'docStatusDefinitionS' },
  partiallySuperseded: { status: 'partiallySuperseded', className: 'partiallySuperseded', labelKey: 'docStatusP' },
  current: { status: 'current', className: 'current', labelKey: 'docStatusCur', definitionKey: 'docStatusDefinitionCur' },
  CUR: { status: 'CUR', className: 'current', labelKey: 'docStatusCur', definitionKey: 'docStatusDefinitionCur' },
  SUP: { status: 'superceded', className: 'superceded', labelKey: 'docStatusS', definitionKey: 'docStatusDefinitionS' },
  C: { status: 'C', className: 'cancelled', labelKey: 'docStatusC', definitionKey: 'docStatusDefinitionC' },
  T: { status: 'T', className: 'cancelled', labelKey: 'docStatusC', definitionKey: 'docStatusDefinitionC' },
  S: { status: 'S', className: 'superceded', labelKey: 'docStatusS', definitionKey: 'docStatusDefinitionS' },
  AVS: { status: 'AVS', className: 'historical', labelKey: 'docStatusAVS', definitionKey: 'docStatusDefinitionAVS' },
  P: { status: 'P', className: 'partiallySuperseded', labelKey: 'docStatusP' },
  O: { status: 'O', className: 'historical', labelKey: 'docStatusO', definitionKey: 'docStatusDefinitionO' },
  RE: { status: 'RE', className: 'historical', labelKey: 'docStatusRE', definitionKey: 'docStatusDefinitionRE' },
  NA: { status: 'NA', className: 'historical', labelKey: 'docStatusNA' },
  W: { status: 'W', className: 'withdrawn', labelKey: 'docStatusW', definitionKey: 'docStatusDefinitionW' },
  AP: { status: 'AP', className: 'historical', labelKey: 'docStatusAP' },
}

export const getDocumentStatus = (item: any): DocumentStatusPresentation | undefined => {
  let statusCode = item?.docStatusCode ?? 'current'

  if (!statusCode) {
    if (item?.cancelled === 'Y') statusCode = 'cancelled'
    else if (item?.superceded === 'Y') statusCode = 'superceded'
    else if (item?.superceded === 'P') statusCode = 'partiallySuperseded'
    else statusCode = 'current'
  }

  return statusMap[statusCode]
}
